import { useRef } from "react";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";
import { SKY_BOTTOM, SKY_HORIZON, SKY_TOP } from "./palette";

const VERTEX_SHADER = /* glsl */ `
  varying float vHeight;
  void main() {
    vHeight = normalize(position).y;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  }
`;

const FRAGMENT_SHADER = /* glsl */ `
  uniform vec3 topColor;
  uniform vec3 horizonColor;
  uniform vec3 bottomColor;
  varying float vHeight;
  void main() {
    float height = clamp(vHeight, -0.25, 1.0);
    vec3 color = height >= 0.0
      ? mix(horizonColor, topColor, pow(height, 0.62))
      : mix(horizonColor, bottomColor, clamp(-height * 2.5, 0.0, 1.0));
    gl_FragColor = vec4(color, 1.0);
  }
`;

/** A camera-following gradient dome. Cheaper than a skybox and needs no art. */
export function SkyDome() {
  const meshRef = useRef<THREE.Mesh>(null);

  useFrame(({ camera }) => {
    if (meshRef.current) {
      meshRef.current.position.copy(camera.position);
    }
  });

  return (
    <mesh ref={meshRef} renderOrder={-100} frustumCulled={false}>
      <sphereGeometry args={[2200, 16, 8]} />
      <shaderMaterial
        side={THREE.BackSide}
        depthWrite={false}
        fog={false}
        toneMapped={false}
        uniforms={{
          topColor: { value: new THREE.Color(SKY_TOP) },
          horizonColor: { value: new THREE.Color(SKY_HORIZON) },
          bottomColor: { value: new THREE.Color(SKY_BOTTOM) },
        }}
        vertexShader={VERTEX_SHADER}
        fragmentShader={FRAGMENT_SHADER}
      />
    </mesh>
  );
}
